module.exports = __webpack_public_path__ + "assets/img/Best-News-Analysis-Provider.bee55c36.png";